import { configureHooks } from '../providers';
import { useProductLoad, useSupportEntry } from './application';

export const hooks = configureHooks({
    products: { hook: useProductLoad },
    supportEntry: { hook: useSupportEntry }
});

export const useHook = hooks.useHook;
